import { type UseHeadInput } from '@unhead/vue';
import { type VueHeadClient, createHead } from '@unhead/vue/client';

// ts is yelling at me if i don't explicit define the return type in this app.
export const unhead: VueHeadClient<UseHeadInput, boolean> = createHead();
